var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.665 10.1879C15.8811 5.404 8.1248 5.404 3.34088 10.1879C3.04798 10.4808 2.57311 10.4808 2.28022 10.1879C1.98732 9.89502 1.98732 9.42015 2.28022 9.12726C7.64993 3.75755 16.3559 3.75755 21.7257 9.12726C22.0185 9.42015 22.0185 9.89502 21.7257 10.1879C21.4328 10.4808 20.9579 10.4808 20.665 10.1879Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8368 13.0163C14.6149 9.79452 9.39132 9.79452 6.16949 13.0163C5.8766 13.3092 5.40172 13.3092 5.10883 13.0163C4.81594 12.7235 4.81594 12.2486 5.10883 11.9557C8.91644 8.14808 15.0898 8.14808 18.8974 11.9557C19.1903 12.2486 19.1903 12.7235 18.8974 13.0163C18.6045 13.3092 18.1296 13.3092 17.8368 13.0163Z",
    className: "Icon-fill-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0083 15.8448C13.3485 14.185 10.6576 14.185 8.99786 15.8448C8.70497 16.1377 8.23009 16.1377 7.9372 15.8448C7.64431 15.5519 7.64431 15.077 7.9372 14.7841C10.1827 12.5386 13.8234 12.5386 16.0689 14.7841C16.3618 15.077 16.3618 15.5519 16.0689 15.8448C15.776 16.1377 15.3012 16.1377 15.0083 15.8448Z",
    className: "Icon-fill-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0049 17.85C13.0049 18.4023 12.5572 18.85 12.0049 18.85C11.4526 18.85 11.0049 18.4023 11.0049 17.85C11.0049 17.2977 11.4526 16.85 12.0049 16.85C12.5572 16.85 13.0049 17.2977 13.0049 17.85Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/Wifi.f874520a2f41c9496b75e40c0aaa1ad7.svg";
export { ForwardRef as ReactComponent };